import { render, staticRenderFns } from "./lot_stock.vue?vue&type=template&id=5379f754&scoped=true"
import script from "./lot_stock.vue?vue&type=script&lang=js"
export * from "./lot_stock.vue?vue&type=script&lang=js"
import style0 from "./lot_stock.vue?vue&type=style&index=0&id=5379f754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5379f754",
  null
  
)

export default component.exports